import React from 'react';
import styles from './styles.module.scss';
import enhance from './enhance';

const text = {
  saving: 'Saving...',
};

const SavingWorkingStateModal = () => (
  <div className={styles.savingModalContainer}>
    <div className={styles.savingModalContent}>
      <p className={styles.savingModalText}>{text.saving}</p>
    </div>
  </div>
);

export default enhance(SavingWorkingStateModal);
